<!--TODO: Create Web component in Skeletor-->
<div class="position-relative" (click)="toggleDropdown = !toggleDropdown">
  <gl-button
    color-primary
    [disabled]="isDisabled"
    dropdown="true"
    [attr.data-activates]="'students-dropdown'"
    title="{{ (isDisabled ? null : title) | translate }}"
    text="{{ text | translate }}"
    icon-left="glicon-user-plus"
    [tooltip]="tooltip | translate"
    [tooltipLeft]="tooltipLeft"
  ></gl-button>
  <ul id="dropdown-{{ id }}" class="gl-dropdown-content" [ngClass]="{ showed: toggleDropdown }">
    <ng-content></ng-content>
  </ul>
</div>
